
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("g6sGq", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $g9Jfe = parcelRequire("g9Jfe");


var $kNUwp = parcelRequire("kNUwp");


var $johDC = parcelRequire("johDC");


var $hQrJ0 = parcelRequire("hQrJ0");


var $2r1Ib = parcelRequire("2r1Ib");


var $cUnEd = parcelRequire("cUnEd");


var $eGMPj = parcelRequire("eGMPj");


var $jGdks = parcelRequire("jGdks");


var $eRbBT = parcelRequire("eRbBT");


var $bHqzo = parcelRequire("bHqzo");


var $gpcGZ = parcelRequire("gpcGZ");


var $gM8Lm = parcelRequire("gM8Lm");


var $khsIl = parcelRequire("khsIl");


var $78z3f = parcelRequire("78z3f");


var $cy0MC = parcelRequire("cy0MC");


var $3uwoQ = parcelRequire("3uwoQ");


var $8lxX2 = parcelRequire("8lxX2");


var $4N1C2 = parcelRequire("4N1C2");


var $7JSTC = parcelRequire("7JSTC");

const $73e079d2547aadd6$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $73e079d2547aadd6$var$BITBUCKET_WORKSPACE_ARI = 'ari:cloud:bitbucket::workspace';
const $73e079d2547aadd6$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
/**
 * Normalizes product names from ARIs to match our product keys.
 * Backend uses 'jira-software' in ARIs but we use 'jira' as the product key.
 */ const $73e079d2547aadd6$var$normalizeProductFromAri = (ariProduct)=>{
    if (ariProduct === 'jira-software') return (0, $gpcGZ.ProductKeys1P).Jira;
    return ariProduct;
};
/**
 * Nouns configuration (simplified - no icons for now)
 */ const $73e079d2547aadd6$var$supportedNouns = {
    [(0, $gpcGZ.NounKeys).project]: {},
    [(0, $gpcGZ.NounKeys).goal]: {},
    [(0, $gpcGZ.NounKeys).AtlassianWebCrawler]: {}
};
/**
 * All product keys - 1P combined with 3P
 */ const $73e079d2547aadd6$var$allProductKeys = [
    ...Object.values((0, $gpcGZ.ARI_EXTRACTED_1P_KEYS)),
    ...(0, $cy0MC.ThirdPartyConfigs).keys()
];
/**
 * Some products (eg. Loom) have separate auth checks that need to be enforced before
 * returning the final list of accessible products.
 *
 * Remove when cleaning up fg('rovo-search-combined-loom-auth')
 */ const $73e079d2547aadd6$var$lastMileProductChecks = (isUserLoomAuthed, products)=>{
    if (!products || products.length === 0) return products;
    return products.filter((product)=>isUserLoomAuthed || product !== (0, $78z3f.ProductKeys3P).Loom);
};
const $73e079d2547aadd6$export$2b0ac18f7cd43e19 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(90);
    const { cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics } = t0;
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $42omo.useState)(false);
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $42omo.useState)(false);
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $42omo.useState)(undefined);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            nouns: []
        };
        $[0] = t1;
    } else t1 = $[0];
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $42omo.useState)(t1);
    let t2;
    bb0: {
        if (!cloudIdProp && firstPartyResponse) {
            let t3;
            if ($[1] !== firstPartyResponse) {
                t3 = (0, $gM8Lm.getFirstCloudId)(firstPartyResponse);
                $[1] = firstPartyResponse;
                $[2] = t3;
            } else t3 = $[2];
            t2 = t3;
            break bb0;
        }
        t2 = "";
    }
    const firstCloudId = t2;
    const t3 = cloudIdProp || firstCloudId || "";
    let t4;
    if ($[3] !== analytics || $[4] !== experience || $[5] !== t3 || $[6] !== thirdPartyAbsoluteUrl || $[7] !== thirdPartyDisabled || $[8] !== userId) {
        t4 = {
            cloudId: t3,
            userId: userId,
            absoluteUrl: thirdPartyAbsoluteUrl,
            disabled: thirdPartyDisabled,
            experience: experience,
            analytics: analytics
        };
        $[3] = analytics;
        $[4] = experience;
        $[5] = t3;
        $[6] = thirdPartyAbsoluteUrl;
        $[7] = thirdPartyDisabled;
        $[8] = userId;
        $[9] = t4;
    } else t4 = $[9];
    const thirdPartyResponse = $73e079d2547aadd6$export$4fc2f66fb6e9d067(t4);
    let t5;
    let t6;
    if ($[10] !== aggAbsoluteUrl || $[11] !== cloudIdProp || $[12] !== firstCloudId || $[13] !== logException || $[14] !== multiSiteSearchInRovo) {
        t5 = ()=>{
            const cloudId = cloudIdProp || firstCloudId;
            if (cloudId && multiSiteSearchInRovo) (0, $johDC.searchLinkedSitesQuery)({
                variables: {
                    id: `ari:cloud:confluence::site/${cloudId}`
                },
                aggAbsoluteUrl: aggAbsoluteUrl
            }).then((response)=>{
                const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
                const linkedARIs = edges.map($73e079d2547aadd6$var$_temp);
                const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
                const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
                if (currentIndex > 0) {
                    linkedARIs.splice(currentIndex, 1);
                    linkedARIs.unshift(currentCloudIdARI);
                }
                setLinkedCloudARIs(linkedARIs);
            }).catch((error)=>{
                logException(error);
            });
        };
        t6 = [
            cloudIdProp,
            firstCloudId,
            multiSiteSearchInRovo,
            logException,
            aggAbsoluteUrl
        ];
        $[10] = aggAbsoluteUrl;
        $[11] = cloudIdProp;
        $[12] = firstCloudId;
        $[13] = logException;
        $[14] = multiSiteSearchInRovo;
        $[15] = t5;
        $[16] = t6;
    } else {
        t5 = $[15];
        t6 = $[16];
    }
    (0, $42omo.useEffect)(t5, t6);
    let t7;
    let t8;
    if ($[17] !== cloudIdProp || $[18] !== isUserLoomAuthed || $[19] !== logException || $[20] !== primaryProduct || $[21] !== userId) {
        t7 = ()=>{
            if (!(0, $g9Jfe.fg)("rovo-search-combined-loom-auth") && !isUserLoomAuthed) {
                if (primaryProduct === (0, $bHqzo.PrimaryProductKeys).Confluence || primaryProduct === (0, $bHqzo.PrimaryProductKeys).Atlas || (primaryProduct === (0, $bHqzo.PrimaryProductKeys).Jira || primaryProduct === (0, $bHqzo.PrimaryProductKeys).Focus) && (0, $g9Jfe.fg)("search_loom_auth_check_in_jira_mercury")) (0, $kNUwp.getUserLoomAuthStatus)({
                    userId: userId,
                    cloudId: cloudIdProp
                }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === "mastered")).catch((error_0)=>{
                    logException(error_0);
                    setIsUserLoomAuthed(false);
                });
                else setIsUserLoomAuthed(true);
            }
        };
        t8 = [
            isUserLoomAuthed,
            setIsUserLoomAuthed,
            userId,
            logException,
            cloudIdProp,
            primaryProduct
        ];
        $[17] = cloudIdProp;
        $[18] = isUserLoomAuthed;
        $[19] = logException;
        $[20] = primaryProduct;
        $[21] = userId;
        $[22] = t7;
        $[23] = t8;
    } else {
        t7 = $[22];
        t8 = $[23];
    }
    (0, $42omo.useEffect)(t7, t8);
    let t10;
    let t9;
    if ($[24] !== actionSubject || $[25] !== aggregatorHostName || $[26] !== cloudIdProp || $[27] !== configFetchAbsoluteUrl || $[28] !== createNetworkCallbacks || $[29] !== experience || $[30] !== fireAnalyticsEvent || $[31] !== firstPartyResponse || $[32] !== logException || $[33] !== searchSessionId || $[34] !== source || $[35] !== taskNamePrefix || $[36] !== userId) {
        t9 = ()=>{
            if (!firstPartyResponse) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3uwoQ.onDegradedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3uwoQ.onRequestCacheAccess)({
                        requestName: "search-config",
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    absoluteUrl: configFetchAbsoluteUrl,
                    hostName: aggregatorHostName,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: 900000,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks
                };
                fireAnalyticsEvent((0, $3uwoQ.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                (0, $kNUwp.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                    setFirstPartyResponse(response_1);
                    fireAnalyticsEvent((0, $3uwoQ.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error_1)=>{
                    logException(error_1);
                    fireAnalyticsEvent((0, $3uwoQ.onFailedDependency)({
                        dependency: "search-config",
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3uwoQ.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error_1.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        intercomHmac: "",
                        siteMetadata: []
                    });
                });
            }
        };
        t10 = [
            firstPartyResponse,
            setFirstPartyResponse,
            cloudIdProp,
            configFetchAbsoluteUrl,
            aggregatorHostName,
            userId,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[24] = actionSubject;
        $[25] = aggregatorHostName;
        $[26] = cloudIdProp;
        $[27] = configFetchAbsoluteUrl;
        $[28] = createNetworkCallbacks;
        $[29] = experience;
        $[30] = fireAnalyticsEvent;
        $[31] = firstPartyResponse;
        $[32] = logException;
        $[33] = searchSessionId;
        $[34] = source;
        $[35] = taskNamePrefix;
        $[36] = userId;
        $[37] = t10;
        $[38] = t9;
    } else {
        t10 = $[37];
        t9 = $[38];
    }
    (0, $42omo.useEffect)(t9, t10);
    let t11;
    if ($[39] !== accessibleProductsConfig.products || $[40] !== cloudIdProp || $[41] !== firstPartyResponse || $[42] !== primaryProduct || $[43] !== thirdPartyResponse.productKeys || $[44] !== thirdPartyResponse.thirdPartyConfigs) {
        t11 = ()=>{
            if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
                let allAccessibleProducts = [];
                const firstPartyProducts = [
                    ...new Set(firstPartyResponse.resources.flatMap($73e079d2547aadd6$var$_temp2))
                ];
                if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
                else allAccessibleProducts.push(...firstPartyProducts);
                const areNounsEnabledThroughLegacyFlag = (0, $jGdks.isNounsAvailable)(firstPartyResponse, cloudIdProp);
                const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap($73e079d2547aadd6$var$_temp3);
                if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $gpcGZ.ProductKeys1P).Atlas);
                if (allAccessibleProducts.includes("bitbucket") && !firstPartyResponse.resources.find($73e079d2547aadd6$var$_temp4)) allAccessibleProducts = allAccessibleProducts.filter($73e079d2547aadd6$var$_temp5);
                const doesUserHaveRovo = (0, $eRbBT.isRovoEnabled)(firstPartyResponse, cloudIdProp);
                if (doesUserHaveRovo) {
                    const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                    allAccessibleProducts.push(...thirdPartyProductKeys);
                    setAccessibleProductsConfig({
                        products: allAccessibleProducts,
                        nouns: accessibleNouns,
                        thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                    });
                } else setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: {}
                });
                setIsConfigLoaded(true);
            }
        };
        $[39] = accessibleProductsConfig.products;
        $[40] = cloudIdProp;
        $[41] = firstPartyResponse;
        $[42] = primaryProduct;
        $[43] = thirdPartyResponse.productKeys;
        $[44] = thirdPartyResponse.thirdPartyConfigs;
        $[45] = t11;
    } else t11 = $[45];
    let t12;
    if ($[46] !== accessibleProductsConfig.products || $[47] !== cloudIdProp || $[48] !== fireAnalyticsEvent || $[49] !== firstPartyResponse || $[50] !== isUserLoomAuthed || $[51] !== logException || $[52] !== primaryProduct || $[53] !== thirdPartyResponse) {
        t12 = [
            isUserLoomAuthed,
            thirdPartyResponse,
            firstPartyResponse,
            setAccessibleProductsConfig,
            primaryProduct,
            fireAnalyticsEvent,
            logException,
            cloudIdProp,
            accessibleProductsConfig.products
        ];
        $[46] = accessibleProductsConfig.products;
        $[47] = cloudIdProp;
        $[48] = fireAnalyticsEvent;
        $[49] = firstPartyResponse;
        $[50] = isUserLoomAuthed;
        $[51] = logException;
        $[52] = primaryProduct;
        $[53] = thirdPartyResponse;
        $[54] = t12;
    } else t12 = $[54];
    (0, $42omo.useEffect)(t11, t12);
    let t13;
    if ($[55] !== accessibleProductsConfig.products || $[56] !== isUserLoomAuthed) {
        t13 = (0, $g9Jfe.fg)("rovo-search-combined-loom-auth") ? accessibleProductsConfig.products : $73e079d2547aadd6$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
        $[55] = accessibleProductsConfig.products;
        $[56] = isUserLoomAuthed;
        $[57] = t13;
    } else t13 = $[57];
    const accessibleProducts = t13;
    const t14 = accessibleProductsConfig.nouns;
    const t15 = accessibleProductsConfig.thirdPartyConfigs;
    const t16 = firstPartyResponse?.intercomHmac;
    let t17;
    if ($[58] !== cloudIdProp || $[59] !== firstPartyResponse) {
        t17 = (0, $jGdks.isNounsAvailable)(firstPartyResponse, cloudIdProp);
        $[58] = cloudIdProp;
        $[59] = firstPartyResponse;
        $[60] = t17;
    } else t17 = $[60];
    let t18;
    if ($[61] !== cloudIdProp || $[62] !== firstPartyResponse) {
        t18 = (0, $eRbBT.isRovoEnabled)(firstPartyResponse, cloudIdProp);
        $[61] = cloudIdProp;
        $[62] = firstPartyResponse;
        $[63] = t18;
    } else t18 = $[63];
    let t19;
    if ($[64] !== cloudIdProp || $[65] !== firstPartyResponse) {
        t19 = (0, $hQrJ0.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp);
        $[64] = cloudIdProp;
        $[65] = firstPartyResponse;
        $[66] = t19;
    } else t19 = $[66];
    let t20;
    if ($[67] !== cloudIdProp || $[68] !== firstPartyResponse) {
        t20 = (0, $cUnEd.getProductEdition)(firstPartyResponse, cloudIdProp);
        $[67] = cloudIdProp;
        $[68] = firstPartyResponse;
        $[69] = t20;
    } else t20 = $[69];
    let t21;
    if ($[70] !== cloudIdProp || $[71] !== firstPartyResponse) {
        t21 = (0, $2r1Ib.getProductDataRegions)(firstPartyResponse, cloudIdProp);
        $[70] = cloudIdProp;
        $[71] = firstPartyResponse;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] !== cloudIdProp || $[74] !== firstPartyResponse) {
        t22 = (0, $eGMPj.getRovoFeatures)(firstPartyResponse, cloudIdProp);
        $[73] = cloudIdProp;
        $[74] = firstPartyResponse;
        $[75] = t22;
    } else t22 = $[75];
    let t23;
    if ($[76] !== accessibleProducts || $[77] !== accessibleProductsConfig.nouns || $[78] !== accessibleProductsConfig.thirdPartyConfigs || $[79] !== firstCloudId || $[80] !== isConfigLoaded || $[81] !== linkedCloudARIs || $[82] !== t16 || $[83] !== t17 || $[84] !== t18 || $[85] !== t19 || $[86] !== t20 || $[87] !== t21 || $[88] !== t22) {
        t23 = {
            accessibleProducts: accessibleProducts,
            accessibleNouns: t14,
            thirdPartyConfigs: t15,
            firstCloudId: firstCloudId,
            intercomHmac: t16,
            isNounsAvailable: t17,
            isRovoEnabled: t18,
            isJiraIssueIndexed: t19,
            productEdition: t20,
            productDataRegions: t21,
            rovoFeatures: t22,
            isConfigLoaded: isConfigLoaded,
            linkedCloudARIs: linkedCloudARIs
        };
        $[76] = accessibleProducts;
        $[77] = accessibleProductsConfig.nouns;
        $[78] = accessibleProductsConfig.thirdPartyConfigs;
        $[79] = firstCloudId;
        $[80] = isConfigLoaded;
        $[81] = linkedCloudARIs;
        $[82] = t16;
        $[83] = t17;
        $[84] = t18;
        $[85] = t19;
        $[86] = t20;
        $[87] = t21;
        $[88] = t22;
        $[89] = t23;
    } else t23 = $[89];
    return t23;
} : ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, thirdPartyAbsoluteUrl: thirdPartyAbsoluteUrl, thirdPartyDisabled: thirdPartyDisabled, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, analytics: analytics })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    const [firstPartyResponse, setFirstPartyResponse] = (0, $42omo.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $42omo.useState)(false);
    // Loom requires a separate auth check
    const [isUserLoomAuthed, setIsUserLoomAuthed] = (0, $42omo.useState)(false);
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $42omo.useState)(undefined);
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $42omo.useState)({
        nouns: []
    });
    const firstCloudId = (0, $42omo.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $gM8Lm.getFirstCloudId)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = $73e079d2547aadd6$export$4fc2f66fb6e9d067({
        cloudId: cloudIdProp || firstCloudId || '',
        userId: userId,
        absoluteUrl: thirdPartyAbsoluteUrl,
        disabled: thirdPartyDisabled,
        experience: experience,
        analytics: analytics
    });
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $42omo.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $johDC.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl
    ]);
    // Loom auth check
    (0, $42omo.useEffect)(()=>{
        if (!(0, $g9Jfe.fg)('rovo-search-combined-loom-auth') && !isUserLoomAuthed) {
            if (primaryProduct === (0, $bHqzo.PrimaryProductKeys).Confluence || primaryProduct === (0, $bHqzo.PrimaryProductKeys).Atlas || (primaryProduct === (0, $bHqzo.PrimaryProductKeys).Jira || primaryProduct === (0, $bHqzo.PrimaryProductKeys).Focus) && (0, $g9Jfe.fg)('search_loom_auth_check_in_jira_mercury')) (0, $kNUwp.getUserLoomAuthStatus)({
                userId: userId,
                cloudId: cloudIdProp
            }).then((response_0)=>setIsUserLoomAuthed(response_0?.status === 'mastered')).catch((error_0)=>{
                logException(error_0);
                setIsUserLoomAuthed(false);
            });
            else setIsUserLoomAuthed(true);
        }
    }, [
        isUserLoomAuthed,
        setIsUserLoomAuthed,
        userId,
        logException,
        cloudIdProp,
        primaryProduct
    ]);
    // Fetch 1P config
    (0, $42omo.useEffect)(()=>{
        if (!firstPartyResponse) {
            const taskStartAt = performance.now();
            const taskId = crypto.randomUUID();
            const degradationCallback = (reason)=>{
                fireAnalyticsEvent((0, $3uwoQ.onDegradedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    reason: reason,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const cacheAnalyticsCallback = async (state)=>{
                fireAnalyticsEvent((0, $3uwoQ.onRequestCacheAccess)({
                    requestName: 'search-config',
                    searchSessionId: searchSessionId,
                    cacheHit: state.hit,
                    refreshTriggered: state.refreshTriggered,
                    source: source,
                    actionSubject: actionSubject
                }));
            };
            const search1PConfigTTL = 900000; // 15 minutes
            const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {}) : undefined;
            const searchConfigParams = {
                cloudId: cloudIdProp,
                absoluteUrl: configFetchAbsoluteUrl,
                hostName: aggregatorHostName,
                userId: userId,
                degradationCallback: degradationCallback,
                cacheAnalyticsCallback: cacheAnalyticsCallback,
                expiration: search1PConfigTTL,
                returnExpired: true,
                onlyRefreshIfExpired: true,
                networkCallbacks: networkCallbacks
            };
            fireAnalyticsEvent((0, $3uwoQ.onTaskStart)({
                searchSessionId: searchSessionId,
                taskId: taskId,
                task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                moreContext: {
                    experience: experience
                }
            }));
            (0, $kNUwp.getSearchConfigV2)(searchConfigParams).then((response_1)=>{
                setFirstPartyResponse(response_1);
                fireAnalyticsEvent((0, $3uwoQ.onTaskSuccess)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
            }).catch((error_1)=>{
                logException(error_1);
                fireAnalyticsEvent((0, $3uwoQ.onFailedDependency)({
                    dependency: 'search-config',
                    searchSessionId: searchSessionId,
                    source: source,
                    actionSubject: actionSubject
                }));
                fireAnalyticsEvent((0, $3uwoQ.onTaskFail)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).FIRST_PARTY_CONFIG_UX),
                    moreContext: {
                        error: error_1.name,
                        timeTaken: performance.now() - taskStartAt,
                        experience: experience
                    }
                }));
                setFirstPartyResponse({
                    resources: [],
                    intercomHmac: '',
                    siteMetadata: []
                });
            });
        }
    }, [
        firstPartyResponse,
        setFirstPartyResponse,
        cloudIdProp,
        configFetchAbsoluteUrl,
        aggregatorHostName,
        userId,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    // Combine 1P and 3P config
    (0, $42omo.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($73e079d2547aadd6$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2) {
                        const normalizedProduct = $73e079d2547aadd6$var$normalizeProductFromAri(match[1]);
                        if ((0, $gpcGZ.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
                            normalizedProduct
                        ];
                        // Loom delivers a 1P-style ARI (ari:cloud:loom::site/...) but is classified
                        // as a 3P product (ProductKeys3P.Loom).
                        if (normalizedProduct === (0, $78z3f.ProductKeys3P).Loom) return [
                            normalizedProduct
                        ];
                    }
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            const areNounsEnabledThroughLegacyFlag = (0, $jGdks.isNounsAvailable)(firstPartyResponse, cloudIdProp);
            const accessibleNouns = areNounsEnabledThroughLegacyFlag ? [] : firstPartyResponse.resources.flatMap((resource_0)=>{
                const { id: id_0 } = resource_0;
                const match_0 = id_0.match($73e079d2547aadd6$var$EXTRACT_PRODUCT);
                if (match_0 && match_0.length >= 2 && match_0[1] in $73e079d2547aadd6$var$supportedNouns) return [
                    match_0[1]
                ];
                return [];
            });
            if (accessibleNouns.length > 0 && !areNounsEnabledThroughLegacyFlag) allAccessibleProducts.push((0, $gpcGZ.ProductKeys1P).Atlas);
            if (allAccessibleProducts.includes('bitbucket') && !firstPartyResponse.resources.find((r)=>r.id.includes($73e079d2547aadd6$var$BITBUCKET_WORKSPACE_ARI))) allAccessibleProducts = allAccessibleProducts.filter((product)=>product !== (0, $gpcGZ.ProductKeys1P).Bitbucket);
            const doesUserHaveRovo = (0, $eRbBT.isRovoEnabled)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        isUserLoomAuthed,
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products
    ]);
    const accessibleProducts = (0, $g9Jfe.fg)('rovo-search-combined-loom-auth') ? accessibleProductsConfig.products : $73e079d2547aadd6$var$lastMileProductChecks(isUserLoomAuthed, accessibleProductsConfig.products);
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        intercomHmac: firstPartyResponse?.intercomHmac,
        isNounsAvailable: (0, $jGdks.isNounsAvailable)(firstPartyResponse, cloudIdProp),
        isRovoEnabled: (0, $eRbBT.isRovoEnabled)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $hQrJ0.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $cUnEd.getProductEdition)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $2r1Ib.getProductDataRegions)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $eGMPj.getRovoFeatures)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs
    };
};
const $73e079d2547aadd6$export$6750011b01164bda = async ()=>{
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': 'sharepoint',
        'ai-3p-connector:google-workspace': 'drive'
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        'lite-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive': 'drive',
        'smartlinks-connector-gdrive-rsl': 'drive',
        'smartlinks-connector-salesforce': 'salesforce',
        'smartlinks-connector-airtable': 'airtable',
        'smartlinks-connector-figma': 'figma',
        'smartlinks-connector-gitlab': 'gitlab',
        'smartlinks-connector-miro': 'miro',
        'smartlinks-connector-asana': 'asana',
        'smartlinks-connector-smartsheet': 'smartsheet',
        'smartlinks-connector-dropbox': 'dropbox',
        'smartlinks-connector-box': 'box',
        'smartlinks-connector-lucid': 'lucid',
        'smartlinks-connector-hubspot': 'hubspot',
        'smartlinks-connector-docusign': 'docusign',
        'smartlinks-connector-slack': 'slack',
        'smartlinks-connector-teams': 'teams',
        'smartlinks-connector-azure-devops': 'azure-devops',
        'smartlinks-connector-notion': 'notion',
        'smartlinks-connector-onedrive': 'onedrive',
        'smartlinks-connector-sharepoint': 'sharepoint'
    };
    await (0, $cy0MC.ThirdPartyConfigs).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
const $73e079d2547aadd6$export$b58c1135b7f9df6d = async ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, degradationCallback: degradationCallback, cacheAnalyticsCallback: cacheAnalyticsCallback, networkCallbacks: networkCallbacks })=>{
    const THIRD_PARTY_TYPES = await $73e079d2547aadd6$export$6750011b01164bda();
    const searchConfigParams = {
        cloudId: cloudId,
        absoluteUrl: absoluteUrl,
        userId: userId,
        degradationCallback: degradationCallback,
        cacheAnalyticsCallback: cacheAnalyticsCallback,
        expiration: 60000,
        // 1 minute
        returnExpired: true,
        onlyRefreshIfExpired: true,
        networkCallbacks: networkCallbacks
    };
    const resources = await (0, $kNUwp.get3pSearchConfig)(searchConfigParams);
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    for (const resource of resources){
        if ((0, $khsIl.isForgeConnectorProductKey)(resource.type) && (0, $g9Jfe.fg)('rovo-search-dynamic-forge-config')) {
            const config = (0, $7JSTC.mapForgeConnectorToThirdPartyConfig)(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            continue;
        }
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) continue;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = await (0, $cy0MC.ThirdPartyConfigs).get(productKey);
        if (staticConfig) {
            const isFederatedNoOAuthConnector = $73e079d2547aadd6$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $khsIl.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $khsIl.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $khsIl.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $khsIl.LITE_CONNECTOR_SOURCE))) sourceType = (0, $khsIl.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $khsIl.FEDERATED_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $khsIl.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $khsIl.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $khsIl.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled
            };
            const datasourceList = [];
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line @typescript-eslint/no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    }
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $khsIl.isForgeConnectorProductKey)(productKey)) return true;
        return $73e079d2547aadd6$var$allProductKeys.includes(productKey);
    });
    return {
        productKeys: filteredProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};
const $73e079d2547aadd6$var$EMPTY_RESPONSE = [];
const $73e079d2547aadd6$export$4fc2f66fb6e9d067 = (0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(29);
    const { cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {};
        $[0] = t1;
    } else t1 = $[0];
    const [config, setConfig] = (0, $42omo.useState)(t1);
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    let t2;
    if ($[1] !== absoluteUrl || $[2] !== actionSubject || $[3] !== cloudId || $[4] !== config.productKeys || $[5] !== createNetworkCallbacks || $[6] !== disabled || $[7] !== experience || $[8] !== fireAnalyticsEvent || $[9] !== logException || $[10] !== searchSessionId || $[11] !== source || $[12] !== taskNamePrefix || $[13] !== userId) {
        t2 = ()=>{
            if (!config.productKeys) {
                if (!disabled && cloudId) {
                    const taskStartAt = performance.now();
                    const taskId = crypto.randomUUID();
                    fireAnalyticsEvent((0, $3uwoQ.onTaskStart)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            experience: experience
                        }
                    }));
                    const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                        experience: experience
                    }) : undefined;
                    const degradationCallback = (reason)=>{
                        fireAnalyticsEvent((0, $3uwoQ.onDegradedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            reason: reason,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    const cacheAnalyticsCallback = async (state)=>{
                        fireAnalyticsEvent((0, $3uwoQ.onRequestCacheAccess)({
                            requestName: "search-3p-config",
                            searchSessionId: searchSessionId,
                            cacheHit: state.hit,
                            refreshTriggered: state.refreshTriggered,
                            source: source,
                            actionSubject: actionSubject
                        }));
                    };
                    $73e079d2547aadd6$export$b58c1135b7f9df6d({
                        cloudId: cloudId,
                        absoluteUrl: absoluteUrl,
                        userId: userId,
                        degradationCallback: degradationCallback,
                        cacheAnalyticsCallback: cacheAnalyticsCallback,
                        networkCallbacks: networkCallbacks
                    }).then((data)=>{
                        setConfig({
                            productKeys: data.productKeys,
                            thirdPartyConfigs: data.thirdPartyConfigs
                        });
                        fireAnalyticsEvent((0, $3uwoQ.onTaskSuccess)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                    }).catch((error)=>{
                        fireAnalyticsEvent((0, $3uwoQ.onFailedDependency)({
                            dependency: "search-3p-config",
                            searchSessionId: searchSessionId,
                            source: source,
                            actionSubject: actionSubject
                        }));
                        fireAnalyticsEvent((0, $3uwoQ.onTaskFail)({
                            searchSessionId: searchSessionId,
                            taskId: taskId,
                            task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                            moreContext: {
                                error: error.name,
                                timeTaken: performance.now() - taskStartAt,
                                experience: experience
                            }
                        }));
                        setConfig({
                            productKeys: $73e079d2547aadd6$var$EMPTY_RESPONSE,
                            thirdPartyConfigs: {}
                        });
                        logException(error);
                    });
                } else setConfig({
                    productKeys: $73e079d2547aadd6$var$EMPTY_RESPONSE,
                    thirdPartyConfigs: {}
                });
            }
        };
        $[1] = absoluteUrl;
        $[2] = actionSubject;
        $[3] = cloudId;
        $[4] = config.productKeys;
        $[5] = createNetworkCallbacks;
        $[6] = disabled;
        $[7] = experience;
        $[8] = fireAnalyticsEvent;
        $[9] = logException;
        $[10] = searchSessionId;
        $[11] = source;
        $[12] = taskNamePrefix;
        $[13] = userId;
        $[14] = t2;
    } else t2 = $[14];
    let t3;
    if ($[15] !== absoluteUrl || $[16] !== actionSubject || $[17] !== cloudId || $[18] !== config || $[19] !== createNetworkCallbacks || $[20] !== disabled || $[21] !== experience || $[22] !== fireAnalyticsEvent || $[23] !== logException || $[24] !== searchSessionId || $[25] !== source || $[26] !== taskNamePrefix || $[27] !== userId) {
        t3 = [
            cloudId,
            absoluteUrl,
            userId,
            disabled,
            config,
            logException,
            fireAnalyticsEvent,
            searchSessionId,
            source,
            actionSubject,
            taskNamePrefix,
            createNetworkCallbacks,
            experience
        ];
        $[15] = absoluteUrl;
        $[16] = actionSubject;
        $[17] = cloudId;
        $[18] = config;
        $[19] = createNetworkCallbacks;
        $[20] = disabled;
        $[21] = experience;
        $[22] = fireAnalyticsEvent;
        $[23] = logException;
        $[24] = searchSessionId;
        $[25] = source;
        $[26] = taskNamePrefix;
        $[27] = userId;
        $[28] = t3;
    } else t3 = $[28];
    (0, $42omo.useEffect)(t2, t3);
    return config;
} : ({ cloudId: cloudId, absoluteUrl: absoluteUrl, userId: userId, disabled: disabled, experience: experience, analytics: analytics })=>{
    const [config, setConfig] = (0, $42omo.useState)({});
    const { fireAnalyticsEvent: fireAnalyticsEvent, logException: logException, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject, taskNamePrefix: taskNamePrefix, createNetworkCallbacks: createNetworkCallbacks } = analytics;
    (0, $42omo.useEffect)(()=>{
        if (!config.productKeys) {
            if (!disabled && cloudId) {
                const taskStartAt = performance.now();
                const taskId = crypto.randomUUID();
                fireAnalyticsEvent((0, $3uwoQ.onTaskStart)({
                    searchSessionId: searchSessionId,
                    taskId: taskId,
                    task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                    moreContext: {
                        experience: experience
                    }
                }));
                const networkCallbacks = createNetworkCallbacks ? createNetworkCallbacks(taskId, (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_NETWORK), searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    experience: experience
                }) : undefined;
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $3uwoQ.onDegradedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    fireAnalyticsEvent((0, $3uwoQ.onRequestCacheAccess)({
                        requestName: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: source,
                        actionSubject: actionSubject
                    }));
                };
                $73e079d2547aadd6$export$b58c1135b7f9df6d({
                    cloudId: cloudId,
                    absoluteUrl: absoluteUrl,
                    userId: userId,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    networkCallbacks: networkCallbacks
                }).then((data)=>{
                    setConfig({
                        productKeys: data.productKeys,
                        thirdPartyConfigs: data.thirdPartyConfigs
                    });
                    fireAnalyticsEvent((0, $3uwoQ.onTaskSuccess)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                }).catch((error)=>{
                    fireAnalyticsEvent((0, $3uwoQ.onFailedDependency)({
                        dependency: 'search-3p-config',
                        searchSessionId: searchSessionId,
                        source: source,
                        actionSubject: actionSubject
                    }));
                    fireAnalyticsEvent((0, $3uwoQ.onTaskFail)({
                        searchSessionId: searchSessionId,
                        taskId: taskId,
                        task: (0, $4N1C2.buildTaskName)(taskNamePrefix, (0, $8lxX2.CONFIG_TASK_SUFFIXES).THIRD_PARTY_CONFIG_UX),
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt,
                            experience: experience
                        }
                    }));
                    setConfig({
                        productKeys: $73e079d2547aadd6$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                    logException(error);
                });
            } else setConfig({
                productKeys: $73e079d2547aadd6$var$EMPTY_RESPONSE,
                thirdPartyConfigs: {}
            });
        }
    }, [
        cloudId,
        absoluteUrl,
        userId,
        disabled,
        config,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        source,
        actionSubject,
        taskNamePrefix,
        createNetworkCallbacks,
        experience
    ]);
    return config;
};
function $73e079d2547aadd6$var$_temp(edge) {
    return edge.node.id;
}
function $73e079d2547aadd6$var$_temp2(resource) {
    const { id: id } = resource;
    const match = id.match($73e079d2547aadd6$var$EXTRACT_PRODUCT);
    if (match && match.length >= 2) {
        const normalizedProduct = $73e079d2547aadd6$var$normalizeProductFromAri(match[1]);
        if ((0, $gpcGZ.ARI_EXTRACTED_1P_KEYS).includes(normalizedProduct)) return [
            normalizedProduct
        ];
        if (normalizedProduct === (0, $78z3f.ProductKeys3P).Loom) return [
            normalizedProduct
        ];
    }
    return [];
}
function $73e079d2547aadd6$var$_temp3(resource_0) {
    const { id: id_0 } = resource_0;
    const match_0 = id_0.match($73e079d2547aadd6$var$EXTRACT_PRODUCT);
    if (match_0 && match_0.length >= 2 && match_0[1] in $73e079d2547aadd6$var$supportedNouns) return [
        match_0[1]
    ];
    return [];
}
function $73e079d2547aadd6$var$_temp4(r) {
    return r.id.includes($73e079d2547aadd6$var$BITBUCKET_WORKSPACE_ARI);
}
function $73e079d2547aadd6$var$_temp5(product) {
    return product !== (0, $gpcGZ.ProductKeys1P).Bitbucket;
}
module.exports["useFetchConfig"] = $73e079d2547aadd6$export$2b0ac18f7cd43e19;
module.exports["useThirdPartyConfig"] = $73e079d2547aadd6$export$4fc2f66fb6e9d067;
module.exports["getThirdPartyTypes"] = $73e079d2547aadd6$export$6750011b01164bda;
module.exports["get3pProductKeys"] = $73e079d2547aadd6$export$b58c1135b7f9df6d;

});

parcelRegister("kNUwp", function(module, exports) {

var $dwp40 = parcelRequire("dwp40");


var $2qzBQ = parcelRequire("2qzBQ");


var $jnPv4 = parcelRequire("jnPv4");


var $3Tbc2 = parcelRequire("3Tbc2");


var $25BDS = parcelRequire("25BDS");


var $7I6bH = parcelRequire("7I6bH");

const $c1ef33da072a3fc0$var$RELATIVE_URL = '/gateway/api/xpsearch-aggregator/configuration/v1';
const $c1ef33da072a3fc0$var$RELATIVE_URL_V2 = '/gateway/api/xpsearch-aggregator/api/v2/configuration';
const $c1ef33da072a3fc0$var$RELATIVE_3P_URL = '/gateway/api/third-party-configuration/connected-data-sources';
const $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL = '/gateway/api/loom-auth/api/internal/identity/user-status';
const $c1ef33da072a3fc0$export$19524a749d98a458 = 'search-config';
const $c1ef33da072a3fc0$export$cf95148f36a28b96 = 'search-3p-config';
const $c1ef33da072a3fc0$export$44d1e7c4ef26c467 = 'loom-user-auth';
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$19524a749d98a458
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch, update: $c1ef33da072a3fc0$var$update3pCache } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$cf95148f36a28b96,
    expiration: 300000
});
const { refreshOnAccessDecorator: $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth } = (0, $jnPv4.promiseCache)({
    name: $c1ef33da072a3fc0$export$44d1e7c4ef26c467
});
const $c1ef33da072a3fc0$var$SITELESS_PRODUCTS = [
    'trello',
    'bitbucket'
];
/**
 * Creates a traceInfoExtractor that reads from a mutable headers reference.
 * Used by REST config endpoints to extract requestId/traceId from HTTP response headers
 * without storing them in the cache.
 */ const $c1ef33da072a3fc0$var$createTraceInfoExtractor = (headersRef)=>{
    return ()=>{
        const headers = headersRef();
        const requestId = headers['atl-request-id'];
        const traceId = headers['x-trace-id'];
        if (requestId || traceId) return {
            requestId: requestId,
            traceId: traceId
        };
        return undefined;
    };
};
const $c1ef33da072a3fc0$export$2e9655e8b4177582 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL}`;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}`);
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options).then((data)=>{
            const resources = data.resources.filter((resource)=>cloudId ? resource.id.includes(cloudId) || $c1ef33da072a3fc0$var$SITELESS_PRODUCTS.find((product)=>resource.id.includes(product)) // Allow access to products that are not associated with a site
                 : true);
            return {
                resources: resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        serveResolvedDuringRefresh: true
    });
};
const $c1ef33da072a3fc0$export$c6f4290269f11bd5 = async ({ absoluteUrl: absoluteUrl = '', hostName: hostName, cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const url = absoluteUrl || `${hostName || ''}${$c1ef33da072a3fc0$var$RELATIVE_URL_V2}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageFirstPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $2qzBQ.generateHash)(`1p|${userId}|${cloudId}|v2`);
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfigPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        }).then((data)=>{
            return {
                resources: data.resources,
                intercomHmac: data.intercomHmac || '',
                siteMetadata: data.siteMetadata || []
            };
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecoratorSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfigPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorSearch({
        key: key.toString(),
        supplier: supplier,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        returnExpired: returnExpired,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$6916ea7f169882e0 = async ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId, userId: userId, onlyRefreshIfExpired: onlyRefreshIfExpired, expiration: expiration, cacheAnalyticsCallback: cacheAnalyticsCallback, degradationCallback: degradationCallback = ()=>{}, returnExpired: returnExpired, networkCallbacks: networkCallbacks })=>{
    const baseUrl = absoluteUrl || $c1ef33da072a3fc0$var$RELATIVE_3P_URL;
    const url = `${baseUrl}/${cloudId}`;
    const queryParams = {
        operationName: 'searchPageThirdPartyConfig'
    };
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        },
        queryParams: queryParams
    };
    const key = (0, $7I6bH.generate3pHash)(userId || '', cloudId || '');
    // Mutable reference for capturing tracing headers from the REST response.
    // Set by the supplier's reportTracingHeaders callback, read by traceInfoExtractor.
    // This avoids storing tracing headers in the cache — they're only used transiently for VitalStats events.
    let capturedTracingHeaders = {};
    const supplier = ()=>{
        capturedTracingHeaders = {};
        const searchConfig3PPromise = (0, $dwp40.utils).requestService({
            url: url
        }, {
            ...options,
            reportTracingHeaders: (headers)=>{
                capturedTracingHeaders = headers;
            }
        });
        // Two cases here, due to the promiseCache from refreshOnAccessDecorator3pSearch below
        // 1. Cache-miss: we of course want to handle degradation!
        // 2. Cache-hit: we actually still want to handle degradation, because if we can't refresh the cache due to a slow dependency, that is a signal we need in healthchecks
        // The alternate approach here would be to wrap the promiseCache in the DegradablePromise, but then we'd only get degradation pings on cache-miss.
        const degrader = new (0, $3Tbc2.DegradablePromise)(searchConfig3PPromise, degradationCallback);
        return degrader.promise();
    };
    const traceInfoExtractor = $c1ef33da072a3fc0$var$createTraceInfoExtractor(()=>capturedTracingHeaders);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecorator3pSearch({
        key: key.toString(),
        supplier: supplier,
        returnExpired: returnExpired,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        expiration: expiration,
        analyticsCallback: cacheAnalyticsCallback,
        networkCallbacks: networkCallbacks,
        serveResolvedDuringRefresh: true,
        traceInfoExtractor: traceInfoExtractor
    });
};
const $c1ef33da072a3fc0$export$b75556aa5958ec1f = (userId, cloudId, updater)=>{
    const key = (0, $7I6bH.generate3pHash)(userId, cloudId);
    return $c1ef33da072a3fc0$var$update3pCache(key.toString(), updater);
};
const $c1ef33da072a3fc0$export$46e3d34ee7b8c58a = async ({ cloudId: cloudId, userId: userId })=>{
    const url = $c1ef33da072a3fc0$var$RELATIVE_LOOM_AUTH_URL;
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $25BDS.generateLoomAuthHash)(userId || '', cloudId || '');
    const supplier = ()=>(0, $dwp40.utils).requestService({
            url: url
        }, options);
    return $c1ef33da072a3fc0$var$refreshOnAccessDecoratorUserLoomAuth({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false
    });
};
module.exports["getSearchConfigV2"] = $c1ef33da072a3fc0$export$c6f4290269f11bd5;
module.exports["get3pSearchConfig"] = $c1ef33da072a3fc0$export$6916ea7f169882e0;
module.exports["update3pConfigCacheEntry"] = $c1ef33da072a3fc0$export$b75556aa5958ec1f;
module.exports["getUserLoomAuthStatus"] = $c1ef33da072a3fc0$export$46e3d34ee7b8c58a;

});

parcelRegister("25BDS", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $5eb733f1658cb27e$export$42b67d93e908c9dc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`loom|${userId}|${cloudId}`);
module.exports["generateLoomAuthHash"] = $5eb733f1658cb27e$export$42b67d93e908c9dc;

});

parcelRegister("7I6bH", function(module, exports) {

var $2qzBQ = parcelRequire("2qzBQ");

const $bf230724a07e1336$export$f80795c7fd0ce9fc = (userId, cloudId)=>(0, $2qzBQ.generateHash)(`3p|${userId}|${cloudId}`);
module.exports["generate3pHash"] = $bf230724a07e1336$export$f80795c7fd0ce9fc;

});

parcelRegister("hQrJ0", function(module, exports) {
const $14ba3f518066cc57$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
module.exports["getJiraIssueIndexedForTenant"] = $14ba3f518066cc57$export$37c9c6a3ae5f363c;

});

parcelRegister("2r1Ib", function(module, exports) {
const $8393c320ce204203$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
module.exports["getProductDataRegions"] = $8393c320ce204203$export$c635d3296555e2da;

});

parcelRegister("cUnEd", function(module, exports) {
const $a8225890445a2b4e$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
module.exports["getProductEdition"] = $a8225890445a2b4e$export$53e066a63a960439;

});

parcelRegister("eGMPj", function(module, exports) {
const $3d67d7b037c29def$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};
module.exports["getRovoFeatures"] = $3d67d7b037c29def$export$2a1c0662041ee0a3;

});

parcelRegister("jGdks", function(module, exports) {
const $4f859493d47d9c47$export$7693a3bd75b4a085 = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isNounsAvailable;
};
module.exports["isNounsAvailable"] = $4f859493d47d9c47$export$7693a3bd75b4a085;

});

parcelRegister("eRbBT", function(module, exports) {
const $6b60aed1aeaf10d4$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
module.exports["isRovoEnabled"] = $6b60aed1aeaf10d4$export$243c13f4da40a98e;

});

parcelRegister("bHqzo", function(module, exports) {
/**
 * Primary product keys represent products that can mount Search Page.
 */ const $233a7270bac6e3fe$export$15d12effc8830544 = {
    Atlas: 'townsquare',
    Confluence: 'confluence',
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Studio: 'studio'
};
module.exports["PrimaryProductKeys"] = $233a7270bac6e3fe$export$15d12effc8830544;

});

parcelRegister("gM8Lm", function(module, exports) {






const $f76239da8641f472$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $f76239da8641f472$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    const match = firstPartyResponse.resources[0]?.id.match($f76239da8641f472$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
module.exports["getFirstCloudId"] = $f76239da8641f472$export$c1871fdf674a03c4;

});

parcelRegister("cy0MC", function(module, exports) {

var $78z3f = parcelRequire("78z3f");


class $fe46503bbd079598$export$50e7f6c2eabc665 {
    /**
   * Returns the number of registered configs.
   */ get size() {
        return this.factories.size;
    }
    /**
   * Checks whether a config is registered for the given key.
   */ has(key) {
        return this.factories.has(key);
    }
    /**
   * Returns all registered product keys synchronously.
   */ keys() {
        return Array.from(this.factories.keys());
    }
    /**
   * Asynchronously retrieves a single config by key.
   * The config module is loaded on first access and cached thereafter.
   */ async get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        const factory = this.factories.get(key);
        if (!factory) return undefined;
        const config = await factory();
        this.cache.set(key, config);
        return config;
    }
    /**
   * Asynchronously iterates over all entries, invoking the callback for each.
   * Each config is lazily loaded as the iteration reaches it.
   */ async forEach(callbackfn) {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) await callbackfn(config, key);
        }
    }
    /**
   * Async generator that yields [key, config] entries lazily.
   */ async *entries() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield [
                key,
                config
            ];
        }
    }
    /**
   * Async generator that yields config values lazily.
   */ async *values() {
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) yield config;
        }
    }
    /**
   * Resolves all configs and returns them as a standard Map.
   * Useful when all configs are needed at once.
   */ async getAll() {
        const result = new Map();
        for (const key of this.factories.keys()){
            const config = await this.get(key);
            if (config) result.set(key, config);
        }
        return result;
    }
    constructor(entries){
        this.factories = void 0;
        this.cache = new Map();
        this.factories = new Map(entries);
    }
}
































































































































































































const $fe46503bbd079598$export$f7937c5f282f2571 = new $fe46503bbd079598$export$50e7f6c2eabc665([
    [
        (0, $78z3f.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("lXPyt")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Figma,
        ()=>(parcelRequire("kSbbT")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Github,
        ()=>(parcelRequire("j7a5S")).then((m)=>m.githubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("5giCX")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("jbjn5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Loom,
        ()=>(parcelRequire("7Q5am")).then((m)=>m.loomConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("3FM2N")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("9wCxQ")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Slack,
        ()=>(parcelRequire("bN9W1")).then((m)=>m.slackConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Teams,
        ()=>(parcelRequire("a7mWX")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("5GAgL")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gmail,
        ()=>(parcelRequire("5RDZb")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("3gkDg")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("eUIe3")).then((m)=>m.outlookMail)
    ],
    [
        (0, $78z3f.ProductKeys3P).Asana,
        ()=>(parcelRequire("1ldrP")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("7UFSv")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Airtable,
        ()=>(parcelRequire("luYHc")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("dfYfn")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Notion,
        ()=>(parcelRequire("8fDYb")).then((m)=>m.notionConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Miro,
        ()=>(parcelRequire("a7dl9")).then((m)=>m.miroConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Docusign,
        ()=>(parcelRequire("i9PCX")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Lucid,
        ()=>(parcelRequire("a3S5N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Monday,
        ()=>(parcelRequire("lVg9n")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("8eQhD")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("cZBTg")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("742DA")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("hbzpt")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("gjDeB")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Canva,
        ()=>(parcelRequire("2qfNJ")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Box,
        ()=>(parcelRequire("kfM4I")).then((m)=>m.boxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zoom,
        ()=>(parcelRequire("25eU8")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("7CHYy")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("4hc3t")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("9AszE")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("03iUQ")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("97S6J")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("jq78f")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Stripe,
        ()=>(parcelRequire("is5P2")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("bimH7")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Aha,
        ()=>(parcelRequire("4zh5J")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("9PYWZ")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Mural,
        ()=>(parcelRequire("c5r1a")).then((m)=>m.muralConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Webex,
        ()=>(parcelRequire("d99vp")).then((m)=>m.webexConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Todoist,
        ()=>(parcelRequire("f3ds7")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("4JAOi")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("7c1le")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("5pcSq")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("1F134")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("JGtJu")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("gho1x")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sentry,
        ()=>(parcelRequire("ks7JI")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("5mTxK")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("k5CUM")).then((m)=>m.awss3Config)
    ],
    [
        (0, $78z3f.ProductKeys3P).Databricks,
        ()=>(parcelRequire("57dT7")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bXMrK")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("7kNK9")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("8NKmn")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("7x1US")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("i7YxP")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("i0xaE")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("29mTI")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("gRwe4")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("bqiFt")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("fe0Dt")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("y4KVk")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("gfnLF")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("8ctPQ")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("jfX0t")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("hErKt")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("8hAEw")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("jODgf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("fCtmT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("4cnAt")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("cUcGj")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("c13EF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("14KEJ")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("4BX8h")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("1uSFT")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("25LKs")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("2dXPn")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("2Q5dG")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("1gtU4")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("kJg29")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("dSKb8")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("ix6UY")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("5j3yx")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("cUNtR")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("1XpjZ")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("67Jws")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("a7z1M")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("5ReGd")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("3vjZr")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("laFm4")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3Dpt4")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("eXfhF")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("jiG4h")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AtlassianWebCrawler,
        ()=>(parcelRequire("lXPyt")).then((m)=>m.atlassianWebCrawlerConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Figma,
        ()=>(parcelRequire("kSbbT")).then((m)=>m.figmaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Github,
        ()=>(parcelRequire("j7a5S")).then((m)=>m.githubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleDrive,
        ()=>(parcelRequire("5giCX")).then((m)=>m.googleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sharepoint,
        ()=>(parcelRequire("jbjn5")).then((m)=>m.sharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Loom,
        ()=>(parcelRequire("7Q5am")).then((m)=>m.loomConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OneDrive,
        ()=>(parcelRequire("3FM2N")).then((m)=>m.oneDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dropbox,
        ()=>(parcelRequire("9wCxQ")).then((m)=>m.dropboxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Slack,
        ()=>(parcelRequire("bN9W1")).then((m)=>m.slackConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Teams,
        ()=>(parcelRequire("a7mWX")).then((m)=>m.teamsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).GoogleCalendar,
        ()=>(parcelRequire("5GAgL")).then((m)=>m.googleCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gmail,
        ()=>(parcelRequire("5RDZb")).then((m)=>m.gmailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookCalendar,
        ()=>(parcelRequire("3gkDg")).then((m)=>m.outlookCalendarConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).OutlookMail,
        ()=>(parcelRequire("eUIe3")).then((m)=>m.outlookMail)
    ],
    [
        (0, $78z3f.ProductKeys3P).Asana,
        ()=>(parcelRequire("1ldrP")).then((m)=>m.asanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zendesk,
        ()=>(parcelRequire("7UFSv")).then((m)=>m.zendeskConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Airtable,
        ()=>(parcelRequire("luYHc")).then((m)=>m.airtableConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Smartsheet,
        ()=>(parcelRequire("dfYfn")).then((m)=>m.smartsheetConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Notion,
        ()=>(parcelRequire("8fDYb")).then((m)=>m.notionConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Miro,
        ()=>(parcelRequire("a7dl9")).then((m)=>m.miroConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Docusign,
        ()=>(parcelRequire("i9PCX")).then((m)=>m.docusignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Lucid,
        ()=>(parcelRequire("a3S5N")).then((m)=>m.lucidConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Monday,
        ()=>(parcelRequire("lVg9n")).then((m)=>m.mondayConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AzureDevops,
        ()=>(parcelRequire("8eQhD")).then((m)=>m.azureDevopsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitlab,
        ()=>(parcelRequire("cZBTg")).then((m)=>m.gitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ConfluenceDC,
        ()=>(parcelRequire("742DA")).then((m)=>m.confluenceDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JiraDC,
        ()=>(parcelRequire("hbzpt")).then((m)=>m.jiraDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).JsmDC,
        ()=>(parcelRequire("gjDeB")).then((m)=>m.jsmDCConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Canva,
        ()=>(parcelRequire("2qfNJ")).then((m)=>m.canvaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Box,
        ()=>(parcelRequire("kfM4I")).then((m)=>m.boxConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zoom,
        ()=>(parcelRequire("25eU8")).then((m)=>m.zoomConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Zeplin,
        ()=>(parcelRequire("7CHYy")).then((m)=>m.zeplinConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ServiceNow,
        ()=>(parcelRequire("4hc3t")).then((m)=>m.serviceNowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Freshservice,
        ()=>(parcelRequire("9AszE")).then((m)=>m.freshserviceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PowerBI,
        ()=>(parcelRequire("03iUQ")).then((m)=>m.powerBIConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ClickUp,
        ()=>(parcelRequire("97S6J")).then((m)=>m.clickUpConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Amplitude,
        ()=>(parcelRequire("jq78f")).then((m)=>m.amplitudeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Stripe,
        ()=>(parcelRequire("is5P2")).then((m)=>m.stripeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeXD,
        ()=>(parcelRequire("bimH7")).then((m)=>m.adobeXDConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Aha,
        ()=>(parcelRequire("4zh5J")).then((m)=>m.ahaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AdobeSign,
        ()=>(parcelRequire("9PYWZ")).then((m)=>m.adobeSignConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Mural,
        ()=>(parcelRequire("c5r1a")).then((m)=>m.muralConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Webex,
        ()=>(parcelRequire("d99vp")).then((m)=>m.webexConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Todoist,
        ()=>(parcelRequire("f3ds7")).then((m)=>m.todoistConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).PagerDuty,
        ()=>(parcelRequire("4JAOi")).then((m)=>m.pagerDutyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Pipedrive,
        ()=>(parcelRequire("7c1le")).then((m)=>m.pipedriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Hubspot,
        ()=>(parcelRequire("5pcSq")).then((m)=>m.hubSpotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Dovetail,
        ()=>(parcelRequire("1F134")).then((m)=>m.dovetailConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).LaunchDarkly,
        ()=>(parcelRequire("JGtJu")).then((m)=>m.launchDarklyConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Salesforce,
        ()=>(parcelRequire("gho1x")).then((m)=>m.salesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Sentry,
        ()=>(parcelRequire("ks7JI")).then((m)=>m.sentryConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).Gitbook,
        ()=>(parcelRequire("5mTxK")).then((m)=>m.gitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).AWSS3,
        ()=>(parcelRequire("k5CUM")).then((m)=>m.awss3Config)
    ],
    [
        (0, $78z3f.ProductKeys3P).Databricks,
        ()=>(parcelRequire("57dT7")).then((m)=>m.databricksConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqDev,
        ()=>(parcelRequire("bXMrK")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeAdamVitareqProd,
        ()=>(parcelRequire("7kNK9")).then((m)=>m.forgeAdamVitareqConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesDev,
        ()=>(parcelRequire("8NKmn")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeK15tScrollSitesProd,
        ()=>(parcelRequire("7x1US")).then((m)=>m.forgeK15tScrollSitesConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsDev,
        ()=>(parcelRequire("i7YxP")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioAwsProd,
        ()=>(parcelRequire("i0xaE")).then((m)=>m.forgePioAwsConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupDev,
        ()=>(parcelRequire("29mTI")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioClickupProd,
        ()=>(parcelRequire("gRwe4")).then((m)=>m.forgePioClickupConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookDev,
        ()=>(parcelRequire("bqiFt")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitbookProd,
        ()=>(parcelRequire("fe0Dt")).then((m)=>m.forgePioGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubDev,
        ()=>(parcelRequire("y4KVk")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGithubProd,
        ()=>(parcelRequire("gfnLF")).then((m)=>m.forgePioGithubConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabDev,
        ()=>(parcelRequire("8ctPQ")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGitlabProd,
        ()=>(parcelRequire("jfX0t")).then((m)=>m.forgePioGitlabConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveDev,
        ()=>(parcelRequire("hErKt")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGoogleDriveProd,
        ()=>(parcelRequire("8hAEw")).then((m)=>m.forgePioGoogleDriveConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruDev,
        ()=>(parcelRequire("jODgf")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioGuruProd,
        ()=>(parcelRequire("fCtmT")).then((m)=>m.forgePioGuruConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceDev,
        ()=>(parcelRequire("4cnAt")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHelpjuiceProd,
        ()=>(parcelRequire("cUcGj")).then((m)=>m.forgePioHelpjuiceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotDev,
        ()=>(parcelRequire("c13EF")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioHubspotProd,
        ()=>(parcelRequire("14KEJ")).then((m)=>m.forgePioHubspotConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceDev,
        ()=>(parcelRequire("4BX8h")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSalesforceProd,
        ()=>(parcelRequire("1uSFT")).then((m)=>m.forgePioSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointDev,
        ()=>(parcelRequire("25LKs")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioSharepointProd,
        ()=>(parcelRequire("2dXPn")).then((m)=>m.forgePioSharepointConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowDev,
        ()=>(parcelRequire("2Q5dG")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgePioStackOverflowProd,
        ()=>(parcelRequire("1gtU4")).then((m)=>m.forgePioStackOverflowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookDev,
        ()=>(parcelRequire("kJg29")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUtoolityGitbookProd,
        ()=>(parcelRequire("dSKb8")).then((m)=>m.forgeUtoolityGitbookConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestDev,
        ()=>(parcelRequire("ix6UY")).then((m)=>m.forgeGdriveEugeneTestDevConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeGdriveEugeneTestProd,
        ()=>(parcelRequire("5j3yx")).then((m)=>m.forgeGdriveEugeneTestProdConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceDev,
        ()=>(parcelRequire("cUNtR")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoSalesforceProd,
        ()=>(parcelRequire("1XpjZ")).then((m)=>m.forgeUnitoSalesforceConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowDev,
        ()=>(parcelRequire("67Jws")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoServicenowProd,
        ()=>(parcelRequire("a7z1M")).then((m)=>m.forgeUnitoServicenowConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeDev,
        ()=>(parcelRequire("5ReGd")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoWrikeProd,
        ()=>(parcelRequire("3vjZr")).then((m)=>m.forgeUnitoWrikeConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaDev,
        ()=>(parcelRequire("laFm4")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoAsanaProd,
        ()=>(parcelRequire("3Dpt4")).then((m)=>m.forgeUnitoAsanaConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampDev,
        ()=>(parcelRequire("eXfhF")).then((m)=>m.forgeUnitoBasecampConfig)
    ],
    [
        (0, $78z3f.ProductKeys3P).ForgeUnitoBasecampProd,
        ()=>(parcelRequire("jiG4h")).then((m)=>m.forgeUnitoBasecampConfig)
    ]
]);
const $fe46503bbd079598$var$productKeys3PValues = new Set(Object.values((0, $78z3f.ProductKeys3P)));
const $fe46503bbd079598$export$985cb3900add20c8 = (value)=>$fe46503bbd079598$var$productKeys3PValues.has(value);
module.exports["ThirdPartyConfigs"] = $fe46503bbd079598$export$f7937c5f282f2571;

});

parcelRegister("lXPyt", function(module, exports) {

let $ffd7196e2aa21d0c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ffd7196e2aa21d0c$var$load("6wr18"),
    $ffd7196e2aa21d0c$var$load("ffEVr"),
    $ffd7196e2aa21d0c$var$load("4VJH4")
]).then(()=>parcelRequire('3vavW'));

});

parcelRegister("kSbbT", function(module, exports) {

let $f321880af40c5094$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f321880af40c5094$var$load("2crxn").then(()=>parcelRequire('8ghR9'));

});

parcelRegister("j7a5S", function(module, exports) {

let $dea6803591198aed$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $dea6803591198aed$var$load("lzJLD").then(()=>parcelRequire('c7moJ'));

});

parcelRegister("5giCX", function(module, exports) {

let $3d4ce55b2f95b948$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3d4ce55b2f95b948$var$load("9joh8").then(()=>parcelRequire('5CdDA'));

});

parcelRegister("jbjn5", function(module, exports) {

let $df6e12296fbd06c0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $df6e12296fbd06c0$var$load("gBTOA").then(()=>parcelRequire('aWbHl'));

});

parcelRegister("7Q5am", function(module, exports) {

let $5b51659af489a46e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5b51659af489a46e$var$load("zSp86"),
    $5b51659af489a46e$var$load("cN8xb")
]).then(()=>parcelRequire('c2Gh1'));

});

parcelRegister("3FM2N", function(module, exports) {

let $2aca77f800146b78$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2aca77f800146b78$var$load("bNNeh").then(()=>parcelRequire('7JjDF'));

});

parcelRegister("9wCxQ", function(module, exports) {

let $6ef5006d92ee2176$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6ef5006d92ee2176$var$load("lsUpD").then(()=>parcelRequire('5rdfZ'));

});

parcelRegister("bN9W1", function(module, exports) {

let $895bfa2e823914a4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $895bfa2e823914a4$var$load("8Tfc6").then(()=>parcelRequire('h08jq'));

});

parcelRegister("a7mWX", function(module, exports) {

let $75dc5c34c604edb7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75dc5c34c604edb7$var$load("c5u8A").then(()=>parcelRequire('hklt8'));

});

parcelRegister("5GAgL", function(module, exports) {

let $423d025aef61b252$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $423d025aef61b252$var$load("l8Dig").then(()=>parcelRequire('7Ybf0'));

});

parcelRegister("5RDZb", function(module, exports) {

let $4450eb559bc7a94c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4450eb559bc7a94c$var$load("ak4AP").then(()=>parcelRequire('apC1g'));

});

parcelRegister("3gkDg", function(module, exports) {

let $2602dedf24439d1d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2602dedf24439d1d$var$load("6J5UB").then(()=>parcelRequire('eaaHo'));

});

parcelRegister("eUIe3", function(module, exports) {

let $adb899f92de85a39$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $adb899f92de85a39$var$load("glsIE").then(()=>parcelRequire('8Q0vI'));

});

parcelRegister("1ldrP", function(module, exports) {

let $0fa22f16462ef166$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0fa22f16462ef166$var$load("b07Rd").then(()=>parcelRequire('eHKKm'));

});

parcelRegister("7UFSv", function(module, exports) {

let $5c2e3f779d00a29c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5c2e3f779d00a29c$var$load("bg9Vn").then(()=>parcelRequire('kuTad'));

});

parcelRegister("luYHc", function(module, exports) {

let $fa6b7b400928f417$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $fa6b7b400928f417$var$load("iZsMy").then(()=>parcelRequire('9o4in'));

});

parcelRegister("dfYfn", function(module, exports) {

let $9a6b68de97aaf03a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9a6b68de97aaf03a$var$load("2xlQN").then(()=>parcelRequire('Wmb4v'));

});

parcelRegister("8fDYb", function(module, exports) {

let $601eba9ba3af4bce$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $601eba9ba3af4bce$var$load("4jTYI").then(()=>parcelRequire('dTyKo'));

});

parcelRegister("a7dl9", function(module, exports) {

let $75d4e7e42aeceb8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75d4e7e42aeceb8e$var$load("38sXo").then(()=>parcelRequire('7BCex'));

});

parcelRegister("i9PCX", function(module, exports) {

let $d3811d5e34ea5f40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d3811d5e34ea5f40$var$load("iJ7i2").then(()=>parcelRequire('7CU5w'));

});

parcelRegister("a3S5N", function(module, exports) {

let $753424d972ed5d43$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $753424d972ed5d43$var$load("hsa3Z").then(()=>parcelRequire('59Q0u'));

});

parcelRegister("lVg9n", function(module, exports) {

let $ff5b72ee8ae2a267$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ff5b72ee8ae2a267$var$load("hM1jk").then(()=>parcelRequire('cQNOi'));

});

parcelRegister("8eQhD", function(module, exports) {

let $5ff82feb1c8dac8b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5ff82feb1c8dac8b$var$load("fhF5c").then(()=>parcelRequire('69fjO'));

});

parcelRegister("cZBTg", function(module, exports) {

let $975892cc7f30d78f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $975892cc7f30d78f$var$load("d47yW").then(()=>parcelRequire('bllsF'));

});

parcelRegister("742DA", function(module, exports) {

let $524af3e644e20bb3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $524af3e644e20bb3$var$load("zSp86"),
    $524af3e644e20bb3$var$load("aJFFV")
]).then(()=>parcelRequire('1vkrr'));

});

parcelRegister("hbzpt", function(module, exports) {

let $c82eee6dd695b569$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c82eee6dd695b569$var$load("zSp86"),
    $c82eee6dd695b569$var$load("fZYxu")
]).then(()=>parcelRequire('9VfJT'));

});

parcelRegister("gjDeB", function(module, exports) {

let $be0cdadcb21dbd6c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $be0cdadcb21dbd6c$var$load("zSp86"),
    $be0cdadcb21dbd6c$var$load("1PT2m")
]).then(()=>parcelRequire('4tJLm'));

});

parcelRegister("2qfNJ", function(module, exports) {

let $1c3a44421e2413b4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1c3a44421e2413b4$var$load("Crim7").then(()=>parcelRequire('d0ffx'));

});

parcelRegister("kfM4I", function(module, exports) {

let $ebea800c80653297$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ebea800c80653297$var$load("3skjv").then(()=>parcelRequire('jOAlg'));

});

parcelRegister("25eU8", function(module, exports) {

let $18479c16f1c61d92$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $18479c16f1c61d92$var$load("eJk4L").then(()=>parcelRequire('5y7Wy'));

});

parcelRegister("7CHYy", function(module, exports) {

let $58ce31ae03275662$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $58ce31ae03275662$var$load("ce7U2").then(()=>parcelRequire('9t8gB'));

});

parcelRegister("4hc3t", function(module, exports) {

let $31d219d14fb77e5a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $31d219d14fb77e5a$var$load("4qZ9f").then(()=>parcelRequire('cbOCM'));

});

parcelRegister("9AszE", function(module, exports) {

let $6fada408892941c1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6fada408892941c1$var$load("7SyXO").then(()=>parcelRequire('hDzfU'));

});

parcelRegister("03iUQ", function(module, exports) {

let $009ef43966481e73$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $009ef43966481e73$var$load("gCAjm").then(()=>parcelRequire('65dnd'));

});

parcelRegister("97S6J", function(module, exports) {

let $6a4ebd1eb8f810df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6a4ebd1eb8f810df$var$load("3DnMk").then(()=>parcelRequire('bfMVn'));

});

parcelRegister("jq78f", function(module, exports) {

let $e235fa4b63786827$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e235fa4b63786827$var$load("aYyxI").then(()=>parcelRequire('eS8nS'));

});

parcelRegister("is5P2", function(module, exports) {

let $d6ef5bb376d80391$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d6ef5bb376d80391$var$load("aoA70").then(()=>parcelRequire('77dhg'));

});

parcelRegister("bimH7", function(module, exports) {

let $8392faccf22f17e5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8392faccf22f17e5$var$load("fKzG5").then(()=>parcelRequire('bRTcz'));

});

parcelRegister("4zh5J", function(module, exports) {

let $3537b04b26fea442$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3537b04b26fea442$var$load("iE1Ii").then(()=>parcelRequire('cBXDq'));

});

parcelRegister("9PYWZ", function(module, exports) {

let $729827fd3ab19458$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $729827fd3ab19458$var$load("d38m9").then(()=>parcelRequire('fWXSj'));

});

parcelRegister("c5r1a", function(module, exports) {

let $8ccae8d670e6eba9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8ccae8d670e6eba9$var$load("3zUfH").then(()=>parcelRequire('ay3nk'));

});

parcelRegister("d99vp", function(module, exports) {

let $99237d383c95ce03$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99237d383c95ce03$var$load("ej4ug").then(()=>parcelRequire('kEEaa'));

});

parcelRegister("f3ds7", function(module, exports) {

let $af519239921f68d7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $af519239921f68d7$var$load("eGFoR").then(()=>parcelRequire('3OpIS'));

});

parcelRegister("4JAOi", function(module, exports) {

let $3727eb27f1fa2796$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3727eb27f1fa2796$var$load("jeRK3").then(()=>parcelRequire('ixnTR'));

});

parcelRegister("7c1le", function(module, exports) {

let $53cab1c96549cab3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $53cab1c96549cab3$var$load("236Pm").then(()=>parcelRequire('1FyJF'));

});

parcelRegister("5pcSq", function(module, exports) {

let $3ef9469e72f2fe54$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3ef9469e72f2fe54$var$load("1EvZx").then(()=>parcelRequire('8QURv'));

});

parcelRegister("1F134", function(module, exports) {

let $135a6efc09d8d2c6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $135a6efc09d8d2c6$var$load("6h2gV").then(()=>parcelRequire('gNXFU'));

});

parcelRegister("JGtJu", function(module, exports) {

let $08952770e1cdaf95$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $08952770e1cdaf95$var$load("eyTTC").then(()=>parcelRequire('eVtI3'));

});

parcelRegister("gho1x", function(module, exports) {

let $bda0de7efc992608$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bda0de7efc992608$var$load("9s2yE").then(()=>parcelRequire('iRR2B'));

});

parcelRegister("ks7JI", function(module, exports) {

let $ee3c6c740cb2bcaa$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ee3c6c740cb2bcaa$var$load("ig6UM").then(()=>parcelRequire('iQ0lV'));

});

parcelRegister("5mTxK", function(module, exports) {

let $3e8a178e6d29cd8a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3e8a178e6d29cd8a$var$load("gh64d").then(()=>parcelRequire('deCcX'));

});

parcelRegister("k5CUM", function(module, exports) {

let $ea0275f3fb362cba$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ea0275f3fb362cba$var$load("5F2rt").then(()=>parcelRequire('3MVdA'));

});

parcelRegister("57dT7", function(module, exports) {

let $3b98610bbf660a4e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3b98610bbf660a4e$var$load("2I5OO").then(()=>parcelRequire('29M8h'));

});

parcelRegister("bXMrK", function(module, exports) {

let $8b5ac8e0b71b4a85$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8b5ac8e0b71b4a85$var$load("jS3rk").then(()=>parcelRequire('blmQP'));

});

parcelRegister("7kNK9", function(module, exports) {

let $5570fcadf3402bc5$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5570fcadf3402bc5$var$load("aR0cI").then(()=>parcelRequire('2UKvr'));

});

parcelRegister("8NKmn", function(module, exports) {

let $6686dc767ef5c39b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $6686dc767ef5c39b$var$load("gsf1a").then(()=>parcelRequire('3ruME'));

});

parcelRegister("7x1US", function(module, exports) {

let $57bd1a07dec93882$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $57bd1a07dec93882$var$load("8DCw4").then(()=>parcelRequire('lwrok'));

});

parcelRegister("i7YxP", function(module, exports) {

let $d327d8523c029ff6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d327d8523c029ff6$var$load("bbk8L").then(()=>parcelRequire('hQVy3'));

});

parcelRegister("i0xaE", function(module, exports) {

let $d1c1f5202db9947d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d1c1f5202db9947d$var$load("dQ5wp").then(()=>parcelRequire('cnErZ'));

});

parcelRegister("29mTI", function(module, exports) {

let $190e2f073bb6166e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $190e2f073bb6166e$var$load("eZRvv").then(()=>parcelRequire('hOS5n'));

});

parcelRegister("gRwe4", function(module, exports) {

let $c46a97f95524cc34$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c46a97f95524cc34$var$load("akCnB").then(()=>parcelRequire('92bi2'));

});

parcelRegister("bqiFt", function(module, exports) {

let $85109a7c7ab42b5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $85109a7c7ab42b5c$var$load("gLftN").then(()=>parcelRequire('jxSYu'));

});

parcelRegister("fe0Dt", function(module, exports) {

let $b158a8102d71115e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b158a8102d71115e$var$load("dWmxR").then(()=>parcelRequire('8c1uN'));

});

parcelRegister("y4KVk", function(module, exports) {

let $0666dd800d0f2f42$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0666dd800d0f2f42$var$load("4DMbb").then(()=>parcelRequire('dN3MD'));

});

parcelRegister("gfnLF", function(module, exports) {

let $bd407bd9a1b253c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $bd407bd9a1b253c4$var$load("4fDnx").then(()=>parcelRequire('7RXfn'));

});

parcelRegister("8ctPQ", function(module, exports) {

let $5f86965f0a1b0d1f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $5f86965f0a1b0d1f$var$load("cAutP").then(()=>parcelRequire('bbdDG'));

});

parcelRegister("jfX0t", function(module, exports) {

let $e04d3087fa57a94f$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e04d3087fa57a94f$var$load("gPTId").then(()=>parcelRequire('k0vWa'));

});

parcelRegister("hErKt", function(module, exports) {

let $cd9bb26245e759cc$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $cd9bb26245e759cc$var$load("5zcDd").then(()=>parcelRequire('ax3yU'));

});

parcelRegister("8hAEw", function(module, exports) {

let $607c57b50393fd2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $607c57b50393fd2a$var$load("efInk").then(()=>parcelRequire('9pKRO'));

});

parcelRegister("jODgf", function(module, exports) {

let $e6d12446a0825f90$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e6d12446a0825f90$var$load("9FFfX").then(()=>parcelRequire('cwJDI'));

});

parcelRegister("fCtmT", function(module, exports) {

let $b5f12f903dbef066$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $b5f12f903dbef066$var$load("1ELM3").then(()=>parcelRequire('4LVIl'));

});

parcelRegister("4cnAt", function(module, exports) {

let $30ea9460d59d3871$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $30ea9460d59d3871$var$load("96rkP").then(()=>parcelRequire('h9iwl'));

});

parcelRegister("cUcGj", function(module, exports) {

let $96548d44ae46d3df$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $96548d44ae46d3df$var$load("6QuMy").then(()=>parcelRequire('5gYzJ'));

});

parcelRegister("c13EF", function(module, exports) {

let $8bf869d52b2efe10$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $8bf869d52b2efe10$var$load("2kEIi").then(()=>parcelRequire('du9hX'));

});

parcelRegister("14KEJ", function(module, exports) {

let $0c8a5b110d1ff2f6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0c8a5b110d1ff2f6$var$load("gUgzh").then(()=>parcelRequire('do3W8'));

});

parcelRegister("4BX8h", function(module, exports) {

let $35b87ca31867afa3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $35b87ca31867afa3$var$load("c3tm1").then(()=>parcelRequire('5Bb9f'));

});

parcelRegister("1uSFT", function(module, exports) {

let $1173010fedc9fdc3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1173010fedc9fdc3$var$load("5yCzB").then(()=>parcelRequire('goA9n'));

});

parcelRegister("25LKs", function(module, exports) {

let $1861163ba527f6f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $1861163ba527f6f9$var$load("7nuxo").then(()=>parcelRequire('73rhf'));

});

parcelRegister("2dXPn", function(module, exports) {

let $19eb342eef84e9fb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $19eb342eef84e9fb$var$load("ckXG3").then(()=>parcelRequire('1IR6D'));

});

parcelRegister("2Q5dG", function(module, exports) {

let $21147ca23421a786$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $21147ca23421a786$var$load("jEwSQ").then(()=>parcelRequire('dY2MK'));

});

parcelRegister("1gtU4", function(module, exports) {

let $0ebe7b3cd4b8b816$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $0ebe7b3cd4b8b816$var$load("c600U").then(()=>parcelRequire('6IFfo'));

});

parcelRegister("kJg29", function(module, exports) {

let $f1747293f8ad7fb4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f1747293f8ad7fb4$var$load("8gYr2").then(()=>parcelRequire('djETu'));

});

parcelRegister("dSKb8", function(module, exports) {

let $a1b42396f738d90a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a1b42396f738d90a$var$load("2nJZw").then(()=>parcelRequire('4FjHU'));

});

parcelRegister("ix6UY", function(module, exports) {

let $d7e0accd0d37ca18$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $d7e0accd0d37ca18$var$load("1gcQ5").then(()=>parcelRequire('cQLav'));

});

parcelRegister("5j3yx", function(module, exports) {

let $3dd17c40e9688a15$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3dd17c40e9688a15$var$load("4Wx4n").then(()=>parcelRequire('lghXu'));

});

parcelRegister("cUNtR", function(module, exports) {

let $026d2dd1cf1ff271$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $026d2dd1cf1ff271$var$load("bTTil").then(()=>parcelRequire('il47H'));

});

parcelRegister("1XpjZ", function(module, exports) {

let $16cef175c069b9f2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $16cef175c069b9f2$var$load("bR8yE").then(()=>parcelRequire('6SplI'));

});

parcelRegister("67Jws", function(module, exports) {

let $4756b55b65df0631$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $4756b55b65df0631$var$load("ha0dM").then(()=>parcelRequire('fibiE'));

});

parcelRegister("a7z1M", function(module, exports) {

let $75e5baa037c8972a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $75e5baa037c8972a$var$load("lkuRr").then(()=>parcelRequire('4eIDA'));

});

parcelRegister("5ReGd", function(module, exports) {

let $443d4a16fd9854f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $443d4a16fd9854f7$var$load("cIyFe").then(()=>parcelRequire('3Cz7D'));

});

parcelRegister("3vjZr", function(module, exports) {

let $28d3c5eb618df751$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $28d3c5eb618df751$var$load("inj26").then(()=>parcelRequire('3TyJ3'));

});

parcelRegister("laFm4", function(module, exports) {

let $f69a9c612d23acf6$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f69a9c612d23acf6$var$load("4M3vA").then(()=>parcelRequire('86B61'));

});

parcelRegister("3Dpt4", function(module, exports) {

let $2a58c4ff7a28f693$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $2a58c4ff7a28f693$var$load("i8qZz").then(()=>parcelRequire('deGo2'));

});

parcelRegister("eXfhF", function(module, exports) {

let $ae326e6dad78c6bb$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $ae326e6dad78c6bb$var$load("boWf5").then(()=>parcelRequire('c0GOq'));

});

parcelRegister("jiG4h", function(module, exports) {

let $e0d05493a76fc5c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $e0d05493a76fc5c4$var$load("lwcwb").then(()=>parcelRequire('lVXgC'));

});

parcelRegister("3uwoQ", function(module, exports) {
const $2ee892a9b18e00b0$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $2ee892a9b18e00b0$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: actionSubject,
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $2ee892a9b18e00b0$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source, actionSubject: actionSubject })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: actionSubject,
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};
const $2ee892a9b18e00b0$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: typeof window !== 'undefined' ? window.location.hostname : '',
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $2ee892a9b18e00b0$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2ee892a9b18e00b0$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $2ee892a9b18e00b0$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2ee892a9b18e00b0$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $2ee892a9b18e00b0$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2ee892a9b18e00b0$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $2ee892a9b18e00b0$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2ee892a9b18e00b0$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onDegradedDependency"] = $2ee892a9b18e00b0$export$e98932ab9e22c265;
module.exports["onFailedDependency"] = $2ee892a9b18e00b0$export$7199f2d13e6ae9f7;
module.exports["onRequestCacheAccess"] = $2ee892a9b18e00b0$export$786813d6840571a0;
module.exports["onTaskStart"] = $2ee892a9b18e00b0$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $2ee892a9b18e00b0$export$3e9761d670712e50;
module.exports["onTaskFail"] = $2ee892a9b18e00b0$export$2e311f5a2c70a936;

});

parcelRegister("8lxX2", function(module, exports) {
/**
 * Task name suffixes for vital stats tracking.
 * The full task name is: `${surfacePrefix}/${TASK_SUFFIX}`
 * e.g., 'search-page/first-party-config-ux' or 'quick-find/first-party-config-ux'
 */ const $ed69fc21099c4a64$export$5f386c08e1416f1e = {
    FIRST_PARTY_CONFIG_UX: 'first-party-config-ux',
    FIRST_PARTY_CONFIG_NETWORK: 'first-party-config-network',
    THIRD_PARTY_CONFIG_UX: 'third-party-config-ux',
    THIRD_PARTY_CONFIG_NETWORK: 'third-party-config-network',
    COMBINED_CONFIG_UX: 'combined-config-ux',
    COMBINED_CONFIG_NETWORK: 'combined-config-network'
};
module.exports["CONFIG_TASK_SUFFIXES"] = $ed69fc21099c4a64$export$5f386c08e1416f1e;

});

parcelRegister("4N1C2", function(module, exports) {

const $77f9ebed3ef164bb$export$577bc64d11eec8be = (surfacePrefix, suffix)=>`${surfacePrefix}/${suffix}`;
module.exports["buildTaskName"] = $77f9ebed3ef164bb$export$577bc64d11eec8be;

});


//# sourceMappingURL=hooks.add39edf.js.map
